module.exports = __webpack_public_path__ + "img/Dragon-Tiger-new.29032ba.png";